<template>
  <!-- 新增地址弹层 -->
  <el-dialog title="新增/修改地址" :visible.sync="dialogVisible" width="700px" :lock-scroll="false" :before-close="handleClose">
    <div class="add_content">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px" class="demo-form">
        <el-form-item label="联系人" prop="userName">
          <el-input v-model="form.userName" style="width:460px;" min="2" maxlength="25"></el-input>
        </el-form-item>
        <el-form-item label="电话号码" prop="userPhone">
          <el-input v-model="form.userPhone" style="width:460px;" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱" prop="userMail">
          <el-input v-model="form.userMail" style="width:460px;" maxlength="80"></el-input>
        </el-form-item>
        <el-form-item label="所在地区" prop="region">
          <el-cascader
            v-model="form.region"
            :options="provincelist"
            :props="props"
            @change="handleChange"
            style="width:460px;"></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址" prop="companyAddress">
          <el-input v-model="form.companyAddress" style="width:460px;" maxlength="200"></el-input>
        </el-form-item>
        <el-form-item label="公司名称" >
          <el-input v-model="form.companyName" style="width:460px;" maxlength="200"></el-input>
        </el-form-item>
        <div style="text-align:center;">
          <el-button type="primary" @click="submitForm('form')" class="popup_content_submitButton sgs-edit-address-button sgs-button">保 存</el-button>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "CreateAddress",
  props: {
    data: {
      type: Object,
      default() {
        return {}
      },
    },
    value: {
      type: Boolean,
      default: false
    },
    apis: {
      type: Object,
      default() {
        return {}
      },
    }
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      const reg = /^[\d\s-+*#]+$/
      if (!reg.test(value)) {
        return callback(new Error('请输入正确的电话号码'));
      } else {
        return callback()
      }
    }
    // 邮箱
    const email = (rule, value, callback) => {
      const mal = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
      if (value) {
        if (!(mal.test(value))) {
          callback(new Error('请输入正确邮箱'))
        } else {
          callback()
        }
      }else{
        callback()
      }
    }
    return {
      dialogVisible: false,
      form: {
        userName:'',
        userPhone:'',
        userMail:'',
        province:'',
        city:'',
        town:'',
        region:[],
        companyName:'',
        companyAddress:''
      },
      rules: {
        userName: [{ required: true, message: '请输入联系人', trigger: 'blur' },
          { min: 2, max: 25, message: '长度在 2 到 25 个字符', trigger: 'blur' }],
        userPhone: [{ required: true, message: '请输入电话号码' }, { validator: validatePhone }],
        userMail:[{ required: false, trigger: "blur"},{validator: email}],
        companyAddress: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
        region:{ required: true, message: '请选择所在地址', trigger: 'change' }
      },
      provincelist: [],
      props:{
        value:'orgName',
        label:'orgName',
        children:'citys'
      },
    }
  },
  watch: {
    value: {
      handler(val) {
        this.dialogVisible = val
      },
      immediate: true
    },
    data: {
      handler(val) {
        if (val.userPhone) {
          this.form = JSON.parse(JSON.stringify(val))
          if (val.province) {
            this.form.region = [val.province]
            if (this.form.city) {
              this.form.region.push(val.city)
              if (this.form.town) {
                this.form.region.push(val.town)
              }
            }
          }
        }
      },
      immediate: true
    }
  },
  created() {
    this.GETPROVINCELIST()
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
      this.$emit('input', false)
    },
    //获取所有的省份
    GETPROVINCELIST(){
      this.apis.GetCityList().then(res => {
        this.provincelist=res.data
      }).catch(e => {
      })
    },
    handleChange(value){
      this.form.province=value[0]
      this.form.city=value[1]
      this.form.town=value[2]
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dialogVisible = false
          this.$emit('input', false)
          this.$emit('updateData', Object.assign({}, this.form))
        } else {
        }
      });
    },
  }
}
</script>

<style scoped>

</style>